export {
  tabsBaseContainerStyles,
  tabsBaseItemStyles,
  tabsBaseListStyles
} from "./tabs-base-styles"
export type { TabsBaseOrientation } from "./tabs-base-styles"
export {
  TabsBaseScrollButtons,
  useTabsBaseOverflowScroll
} from "./tabs-base-overflow-scroll"
export type { TabsBaseScrollButtonsProps } from "./tabs-base-overflow-scroll"
